import React, { useState } from "react";
import { none, Option } from "fp-ts/lib/Option";

import "./App.scss";
import { CalculatorTool } from "./CalculatorTool/CalculatorTool";
import CalculatorResults from "./CalculatorResults/CalculatorResults";
import {
  CalculatorResultsContext,
  ResultStateStore,
} from "./Store/CalculatorResultsContext";
import { CalculatorResponse } from "../model/CalculatorResponse";
import {
  CalculatorConfig,
  emptyCalculatorConfig,
} from "../model/CalculatorConfig";
import {
  createIntialCalculatorSteps,
  CalculatorSteps,
} from "../model/CalculatorSteps";
import { CalculatorStepsContext } from "./Store/CalculatorStepsContext";
import { CalculatorServiceError } from "./CalculatorTool/CalculatorServiceError";
import {
  UserInterfaceHintsContext,
  UserInterfaceHintsStateStore,
} from "./Store/UserInterfaceHintsContext";
import UIContext from "./Store/ui-context";

const App = () => {
  const [config, setConfig] = useState<CalculatorConfig>(emptyCalculatorConfig);
  const initSteps = createIntialCalculatorSteps(config);
  const [steps, setSteps] = useState<CalculatorSteps>(initSteps);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [results, setResults] = useState<Option<CalculatorResponse>>(none);
  const [secondaryResults, setSecondaryResults] =
    useState<Option<CalculatorResponse>>(none);
  const [serviceError, setServiceError] = useState<Option<string>>(none);
  const [resultsLoading, setResultsLoading] = useState<boolean>(false);
  const [exportingPdf, setExportingPdf] = useState<boolean>(false);
  const [exportingPdfCancelled, setExportingPdfCancelled] = useState<boolean>(false);
  const [pdfUrl, setPdfUrl] = useState<Option<string>>(none);
  const [pdfExportError, setPdfExportError] = useState<Option<string>>(none);

  const store = new ResultStateStore(
    config,
    setConfig,
    results,
    setResults,
    secondaryResults,
    setSecondaryResults,
    serviceError,
    setServiceError,
    resultsLoading,
    setResultsLoading,
    exportingPdf,
    setExportingPdf,
    exportingPdfCancelled,
    setExportingPdfCancelled,
    pdfUrl,
    setPdfUrl,
    pdfExportError,
    setPdfExportError
  );

  const [hints, setHints] = useState<Set<string>>(new Set<string>());
  const hintsStore = new UserInterfaceHintsStateStore(hints, setHints);

  return (
    <div className="container">
      <UIContext.Provider value={{ showModal, setShowModal }}>
        <UserInterfaceHintsContext.Provider value={hintsStore}>
          <CalculatorStepsContext.Provider value={{ steps, setSteps }}>
            <CalculatorResultsContext.Provider value={store}>
              {store.hasResults() ? <CalculatorResults /> : <CalculatorTool />}
              <CalculatorServiceError />
            </CalculatorResultsContext.Provider>
          </CalculatorStepsContext.Provider>
        </UserInterfaceHintsContext.Provider>
      </UIContext.Provider>
    </div>
  );
};

export default App;
